import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { setTimeout$ } from 'src/app/core/common';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { JobService } from 'src/app/services/job.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss']
})
export class IframeComponent implements OnInit {

  constructor(private route: ActivatedRoute, private sharedService: SharedService,
    private analyticsService: AnalyticsService, private jobService: JobService, private store: Store) { }

  target: string;
  referrer: string;
  subscribeCriteria: any = {};
  sourceName = '';
  showSubscribe = false;
  job: any;
  user: any;

  async ngOnInit() {
    this.sharedService.setNoIndex();
    this.route.params.subscribe(async params => {
      await this.setData(params);
    });
  }

  private async setData(params) {
    this.referrer = document.referrer;
    const jobId = params['id'];
    if (jobId) {
      this.analyticsService.gtmEvent('show-ifram-A', 'seeker', 'no-subscribe', true);
      this.job = await this.jobService.get(jobId);
      this.user = this.store.selectSnapshot(state => state.auth.user);
      this.showSubscribe = true;
      this.subscribeCriteria = {
        Keyword: JobService.getSearchQuery(this.job),
        State: this.job.State,
        City: this.job.City
      };
      this.target = this.job.SourceUrl;
    }
  }

  redirect(withSubscribe = false) {
    this.analyticsService.gtmEvent('do-redirect-A', 'seeker',
      withSubscribe
        ? 'new-subscribe'
        : (this.showSubscribe ? 'no-subscribe' : 'old-subscribe'));
    //wait for the event to be sent
    setTimeout$(() => {
      window.location.replace(this.target);
    }, 1000);
  }
}
